export default __webpack_public_path__ + "static/media/logo.e5d46eea.svg";